import { api } from "../common/http";
const toPage = (res) => res.data;

const UsersApi = {
  list: async ({
  page = 0,
  size = 20,
  sort = "firstName,asc",
  q,
  country,
  role,
  businessName,
} = {}) => {
  const params = { page, size, sort };

  if (q?.trim()) params.q = q.trim();
  if (country?.trim()) params.country = country.trim();
  if (role) params.role = role;                    
  if (businessName?.trim()) params.businessName = businessName.trim();
  const res = await api.get("/users", { params }); 
  return toPage(res);
},


  listAllBusinessUsers: async ({
    page = 0,
    size = 20,
    sort = "firstName,asc",
    q,
    country,
  } = {}) => {
    const params = { page, size, sort };
    if (q && q.trim()) params.q = q.trim();
    if (country && country.trim()) params.country = country.trim();
    const res = await api.get("/users/business-users", { params });
    return toPage(res);
  },

  listAgents: async ({
    page = 0,
    size = 20,
    sort = "firstName,asc",
    q,
    country,
    activeOnly,
  } = {}) => {
    const params = { page, size, sort };
    if (q && q.trim()) params.q = q.trim();
    if (country && country.trim()) params.country = country.trim();
    if (typeof activeOnly === "boolean") params.active = activeOnly;

    const res = await api.get("/users/agents", { params });
    return toPage(res);
  },

  getById: async (id) => (await api.get(`/users/${id}`)).data,
  getByUuid: async (uuid) => (await api.get(`/users/uuid/${uuid}`)).data,
  create: async (data) => (await api.post("/users", data)).data,
  update: async (id, data) => (await api.put(`/users/${id}`, data)).data,
  updateMe: async (data) => (await api.put("/users/update/me", data)).data,
  remove: async (id) => (await api.delete(`/users/${id}`)).data,
  attachExistingUser: async ({ email, roles }) => {
    const trimmed = typeof email === "string" ? email.trim() : "";
    if (!trimmed) throw new Error("Email is required");
    const normalizedRoles = Array.isArray(roles) ? roles.filter(Boolean) : [];
    if (normalizedRoles.length === 0) throw new Error("Select at least one role.");
    return (await api.post("/users/attach-existing", { email: trimmed, roles: normalizedRoles })).data;
  },
  inviteUser: async ({ email, roles }) => {
    const trimmed = typeof email === "string" ? email.trim() : "";
    if (!trimmed) throw new Error("Email is required");
    const normalizedRoles = Array.isArray(roles) ? roles.filter(Boolean) : [];
    if (normalizedRoles.length === 0) throw new Error("Select at least one role.");
    return api.post("/users/agents/invite", { email: trimmed, roles: normalizedRoles });
  },

  listByRoleAndCountry: async (role, country, { page = 0, size = 20, sort = "firstName,asc" } = {}) => {
    const res = await api.get("/users", { params: { role, country, page, size, sort } });
    return toPage(res);
  },
};

export default UsersApi;
